/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_R2Inputs */



/**
* | output |
* | --- |
* | "R2 Opponent all rounds" |
*
* @param {Rounds_R2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_r2 = /** @type {((inputs?: Rounds_R2Inputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_R2Inputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("R2 Adversaire toutes rondes")
	if (locale === "es") return /** @type {LocalizedString} */ ("R2 Oponente todas las rondas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("R2 Oponente todas as rodadas")
	if (locale === "it") return /** @type {LocalizedString} */ ("R2 Avversario tutti i round")
	return /** @type {LocalizedString} */ ("R2 Opponent all rounds")
});